import { Routes, Route, Navigate } from "react-router-dom";
import ProtectedRoute from "@/components/ProtectedRoute";
import AdSenseScript from "@/components/ads/AdSenseScript";
import AppRouteErrorBoundary from "@/components/AppRouteErrorBoundary";
import Index from "./pages/Index";
import AuthPage from "./pages/AuthPage";
import ExploreProvidersPage from "./pages/ExploreProvidersPage";
import ServicePage from "./pages/ServicePage";
import SubmitListingPage from "./pages/SubmitListingPage";
import UserListingsPage from "./pages/UserListingsPage";
import ProfilePage from "./pages/ProfilePage";
import FavoritesPage from "./pages/FavoritesPage";
import AboutPage from "./pages/AboutPage";
import PricingPage from "./pages/PricingPage";
import TermsPage from "./pages/TermsPage";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import NotFound from "./pages/NotFound";
import UserSubscriptionPage from "./pages/UserSubscriptionPage";
import ProviderAnalyticsPage from "./pages/ProviderAnalyticsPage";
import AdminDashboardPage from "./pages/admin/AdminDashboardPage";
import AdminReviewPage from "./pages/admin/AdminReviewPage";
import AdminCreateListingPage from "./pages/admin/AdminCreateListingPage";
import AdminEditListingPage from "./pages/admin/AdminEditListingPage";
import UserManagementPage from "./pages/admin/UserManagementPage";
import CategoryManagementPage from "./pages/admin/CategoryManagementPage";
import AreaManagementPage from "./pages/admin/AreaManagementPage";
import AppSettingsPage from "./pages/admin/AppSettingsPage";
import SupportApiKeyPage from "./pages/admin/SupportApiKeyPage";
import SubscriptionManagementPage from "./pages/admin/SubscriptionManagementPage";
import ReportedReviewsPage from "./pages/admin/ReportedReviewsPage";
import ReviewModerationPage from "./pages/admin/ReviewModerationPage";
import AdminAnalyticsPage from "./pages/admin/AdminAnalyticsPage";
import IconsPage from "./pages/admin/IconsPage";
import PremiumPaymentPage from "./pages/payment/PremiumPaymentPage";
import WhatsAppPaymentPage from "./pages/payment/WhatsAppPaymentPage";
import AuthCallbackPage from "./pages/auth/AuthCallbackPage";

function App() {
  return (
    <>
      <AdSenseScript />
      <AppRouteErrorBoundary>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<Index />} />
          <Route path="/auth" element={<AuthPage />} />
          <Route path="/auth/callback" element={<AuthCallbackPage />} />
          <Route path="/explore" element={<ExploreProvidersPage />} />
          <Route path="/service/:id" element={<ServicePage />} />
          <Route path="/listing/:id" element={<ServicePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/privacy" element={<PrivacyPolicyPage />} />
          <Route path="/list-your-business" element={<Navigate to="/submit-listing" replace />} />

          {/* Protected Routes */}
          <Route path="/submit-listing" element={<ProtectedRoute><SubmitListingPage /></ProtectedRoute>} />
          <Route path="/user/listings" element={<ProtectedRoute><UserListingsPage /></ProtectedRoute>} />
          <Route path="/profile" element={<ProtectedRoute><ProfilePage /></ProtectedRoute>} />
          <Route path="/favorites" element={<ProtectedRoute><FavoritesPage /></ProtectedRoute>} />
          <Route path="/subscription" element={<ProtectedRoute><UserSubscriptionPage /></ProtectedRoute>} />
          <Route path="/analytics/:providerId" element={<ProtectedRoute><ProviderAnalyticsPage /></ProtectedRoute>} />

          {/* Payment Routes */}
          <Route path="/payment/premium" element={<ProtectedRoute><PremiumPaymentPage /></ProtectedRoute>} />
          <Route path="/payment/whatsapp" element={<ProtectedRoute><WhatsAppPaymentPage /></ProtectedRoute>} />

          {/* Admin Routes */}
          <Route path="/admin" element={<ProtectedRoute adminOnly><AdminDashboardPage /></ProtectedRoute>} />
          <Route path="/admin/review-listings" element={<ProtectedRoute adminOnly><AdminReviewPage /></ProtectedRoute>} />
          <Route path="/admin/create-listing" element={<ProtectedRoute adminOnly><AdminCreateListingPage /></ProtectedRoute>} />
          <Route path="/admin/edit-listing/:id" element={<ProtectedRoute adminOnly><AdminEditListingPage /></ProtectedRoute>} />
          <Route path="/admin/users" element={<ProtectedRoute adminOnly><UserManagementPage /></ProtectedRoute>} />
          <Route path="/admin/categories" element={<ProtectedRoute adminOnly><CategoryManagementPage /></ProtectedRoute>} />
          <Route path="/admin/areas" element={<ProtectedRoute adminOnly><AreaManagementPage /></ProtectedRoute>} />
          <Route path="/admin/settings" element={<ProtectedRoute adminOnly><AppSettingsPage /></ProtectedRoute>} />
          <Route path="/admin/support-api" element={<ProtectedRoute adminOnly><SupportApiKeyPage /></ProtectedRoute>} />
          <Route path="/admin/subscriptions" element={<ProtectedRoute adminOnly><SubscriptionManagementPage /></ProtectedRoute>} />
          <Route path="/admin/reported-reviews" element={<ProtectedRoute adminOnly><ReportedReviewsPage /></ProtectedRoute>} />
          <Route path="/admin/reviews" element={<ProtectedRoute adminOnly><ReviewModerationPage /></ProtectedRoute>} />
          <Route path="/admin/analytics" element={<ProtectedRoute adminOnly><AdminAnalyticsPage /></ProtectedRoute>} />
          <Route path="/admin/icons" element={<ProtectedRoute adminOnly><IconsPage /></ProtectedRoute>} />

          {/* 404 Route */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </AppRouteErrorBoundary>
    </>
  );
}

export default App;
